import React, { useContext } from "react";
import { Handle } from "./Slider.styles";
import SliderContext from "./SliderContext";
import { roundValueToStep, valueToPercentage } from "./Slider.operations";
import useDragEvents from "./useDragEvents";
const SliderHandle = ({
  value,
  id,
  testId,
  className = "",
  updateValue
}) => {
  const { step, sliderSize, disabled, min, max } = useContext(SliderContext);
  const dragEvents = useDragEvents({
    min,
    max,
    value,
    sliderSize,
    step,
    updateValue
  });
  const updateFromKeyPress = (increaseBy) => {
    const newValue = Math.min(max, value + increaseBy);
    updateValue(roundValueToStep(newValue, step, min), true);
  };
  const handleKeyDown = (e) => {
    const { key } = e;
    const largeStep = Math.ceil((max - min) / 10);
    switch (key) {
      case "ArrowRight":
      case "ArrowUp":
      case "PageUp": {
        const increaseBy = key === "PageUp" ? largeStep : step;
        updateFromKeyPress(increaseBy);
        break;
      }
      case "ArrowLeft":
      case "ArrowDown":
      case "PageDown": {
        const decreaseBy = key === "PageDown" ? largeStep : step;
        updateFromKeyPress(-decreaseBy);
        break;
      }
      default:
        break;
    }
  };
  return /* @__PURE__ */ React.createElement(Handle, {
    style: { left: `${valueToPercentage(min, max, value)}%` },
    onMouseDown: dragEvents,
    onTouchStart: dragEvents,
    onKeyDown: handleKeyDown,
    role: "slider",
    id,
    "aria-labelledby": id,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    tabIndex: 0,
    "data-testid": testId,
    className: disabled ? `disabled` : className
  });
};
export default SliderHandle;
